/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { pageContainerWithNavigation } from "../../../../theme/commonStyle";

const passwordPageStyle = {
  headline: {
    textAlign: "center",
    marginTop: "2.5rem",
    marginBottom: "2.5rem",
  },
  formContainer: {
    padding: "1rem",
  },
  title: {
    textAlign: "center",
    margin: "3rem 0",
  },
  form: {
    maxWidth: 700,
    margin: "1rem auto",
  },
  passwordFormControl: {
    marginBottom: "1rem",
  },
  imgDescription: {
    marginTop: "3rem",
    maxWidth: "100%",
  },
  pageContainerWithNavigation,
  buttonMargin: {},
};

export default passwordPageStyle;
